<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select2 from 'vue3-select2-component';
import "@vueform/multiselect/themes/default.css";
import { usePermissions } from '@/composables/usePermissions';
import { formatDateToWeb } from '@/helpers/date-functions';

//import DataTable from 'datatables.net-vue3';
require("@/assets/css/datatable.css");
export default {
  page: {
    title: "Order Information",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Order Information",
      items: [
        {
          text: "Orders",
          href: "/",
        },
      ],

      customer_order_info: [],
      customer_mandate_info: [],
      orderstatusList: [],
      listColor: [],
      customer_first_name: '',
      customer_last_name: '',
      customer_full_name: '',
      order_no: '',
      order_url: '',
      order_version: 1,
      created_at: '',
      data_verification: '',
      call_verification: '',
      program_name: '',
      product_name: '',
      sku: '',
      price: '',
      order_status_name: '',
      order_status_id: '',
      front_nric: '',
      back_nric: '',
      program_fee: '',
      remarks: '',
      cancel_reason:'',
      namepernric:'',
      referralOptions: [],
      selectedReferralId: '',
      referralHistory: [],
      paymentLists:[],
      branchListPickup:[],
      loadingData:true,
      credit_check_result:'',
      payment_status_mandate:'',
      payment_status_upfront:'',
      mandate_status:'Not Paid',
      mandate_date:'',
      instantpay_status:'Not Paid',
      upfrontPaymentDate: '',
      curlec_reference_no: '',
      payment_link:'',
      email_status: '',
      credit_check_request_by: '',
      credit_check_request_datetime: '',
      creditCheckNotActive: true,
      order_id:'',
      dob:'',
      customer_id : this.$route.params.cid,
      retry:0,
      net_salary:'',
      salary_range: '',
      pickup_store: '',
      temp_id: '',
      email_address:'',
      disableGeneratePaymentLink: true,
      disableSendEmail: true,
      credit_check: '',
      nric: '',
      delivery_address: '',
      pickup_store_address: '',
      order_for: '',
      straight_through: '',
      nric_num:'',
      dropoff_cust:'',
      dropoff_temp:'',
      pickup_branch:'',
      credit_check_real:'',
      branchList:'',
      pickupbranch:'',
      delivery_option:'',
      delivery_postcode:'',
      delivery_city:'',
      delivery_state:'',
      country:1,
      server_env: process.env.VUE_APP_SERVER,
      id_order:'',
      tenure: '',
      program_id:'',

      emailconfirm: true,
      buttonskudisable: true,

      has_house_delivery: 0,
      hash: '',
      UploadEPFLinkURL:'',
      securityDeposit: 0,
      knockOffAmount: 0,
      newlyMonthlyAmount: 0,
      version: '',
      supportingDocuments: [],
      bank_name: '',
      bankStatementUrl: '',
      epfStatementUrl: '',
      payslipUrl: '',
      incomeVerificationType: '',
      qualified_tier: '',
      n2Result: '',
      n2Remarks: '',
      requestFormsList: [],
      isAlternativeDeviceChanged: false,
    };
  },
  setup() {
        const permissions = usePermissions();
        
        return {
            permissions,
        };
    },
  computed: {
    isProcessingStatus() {
      const statusName = (this.order_status_name || '').toString().toLowerCase();
      const statusId = Number(this.order_status_id);
      return statusId === 2 || statusName === 'processing';
    },
    isHighValueDevice() {
      const tier = String(this.qualified_tier || '').toUpperCase();
      if (tier === 'HIGH_VALUE') return true;
      const priceVal = parseFloat(this.price) || 0;
      return priceVal >= 300;
    },
  },
  methods: {
    format_date(value){
        if (value) {
            return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
        }
    },

    formatDateToWeb(value, format = 'DD-MMM-YYYY'){
        return formatDateToWeb(value, format);
    },

    displayValue(value, prefix = '') {
        if (value === null || value === undefined || String(value).trim() === '' || String(value).trim() === 'NA' || String(value).trim() === 'null') {
            return '---';
        }
        return prefix + value;
    },

    getCreditCheck(order_id){
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'creditcheck/request/'+order_id)
        .then(response => {
            if (response.data && response.data['0']) {
                this.credit_check_real = response.data['0'].name;
            } else {
                this.credit_check_real = null;
            }
          })
        .catch(error => {
            this.credit_check_real = null;
            this.messageBag = [error.error];
        });
      // 
    },

    get_branch(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'branch/list/'+this.order_for)
        .then(response => {
            if (response) {
                this.branchList = response.data;
                console.log("this.branchList",this.branchList);
                const branchListmap = this.branchList.map((branchList) => {
                    return {
                        id: branchList.id,
                        text: branchList.name,
                    }
                    })
                this.branchList = branchListmap;
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    getBranchForDelivery(){
        axios.get(process.env.VUE_APP_API_BASEURL+'branch/pickup')
        .then(response => {
            if (response) {
              this.branchListPickup = response.data;
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },
    GetCollectionData(){
      
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'dashboard/customer/collection/'+this.$route.params.cid)
            .then(response => {
                if (response) {
                    this.Collection=response.data;
                    this.securityDeposit= this.Collection.security_deposit_amount;
                    this.knockOffAmount= this.Collection.knock_off_amount;
                    this.newlyMonthlyAmount = this.Collection.newly_monthly_amount;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

    get_customer_by_id(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'customer/order_details/'+this.$route.params.cid)
        .then(response => {
          console.log('customer details here', response.data);
            if (response) {
                //this.loadingRoles=false;
                this.customer_order_info = response.data; 
                this.namepernric = this.customer_order_info[0].name_as_per_nric;
                this.customer_first_name = this.customer_order_info[0].first_name;
                this.customer_last_name = this.customer_order_info[0].last_name;
                this.customer_full_name = this.customer_order_info[0].first_name+' '+this.customer_order_info[0].last_name;
                this.order_no = this.customer_order_info[0].orderId;
                this.order_url = this.customer_order_info[0].order_url;
                this.order_version = this.customer_order_info[0].order_version || 1;
                this.created_at = this.format_date(this.customer_order_info[0].created_at);
                this.data_verification = this.customer_order_info[0].data_verification;
                this.call_verification = this.customer_order_info[0].call_verification;
                this.program_name = this.customer_order_info[0].program_name;
                this.product_name = this.customer_order_info[0].product_name;
                this.sku = this.customer_order_info[0].sku;
                this.price = this.customer_order_info[0].price;
                this.order_status_name = this.customer_order_info[0].order_status_name;
                this.order_status_id = this.customer_order_info[0].order_status_id;
                this.front_nric = this.customer_order_info[0].front_nric;
                this.back_nric = this.customer_order_info[0].back_nric;
                this.program_fee = this.customer_order_info[0].program_fee;
                this.tenure = this.customer_order_info[0].tenure;
                this.remarks = this.customer_order_info[0].remarks;
                this.cancel_reason = this.customer_order_info[0].cancel_reason;
                this.credit_check_result = this.customer_order_info[0].credit_check_result;
                this.curlec_reference_no = this.customer_order_info[0].curlec_refno;
                this.credit_check_request_datetime = this.customer_order_info[0].credit_check_date;
                this.order_id = this.customer_order_info[0].order_id;
                this.pickup_store = this.customer_order_info[0].branch_id;
                this.temp_id = this.customer_order_info[0].temp_id;
                this.email_address = this.customer_order_info[0].email;
                this.credit_check = this.customer_order_info[0].credit_check;
                this.id_order = this.customer_order_info[0].id_order;
                // this.delivery_address = this.customer_order_info[0].delivery_address+',\n'+this.customer_order_info[0].delivery_postcode+', '+this.customer_order_info[0].delivery_city+', '+this.customer_order_info[0].delivery_state;
                this.delivery_address = this.customer_order_info[0].delivery_address;
                this.delivery_postcode = this.customer_order_info[0].delivery_postcode;
                this.delivery_city = this.customer_order_info[0].delivery_city;
                this.delivery_state = this.customer_order_info[0].delivery_state;
                this.delivery_state_id = this.customer_order_info[0].delivery_state_id;
                //this.pickup_store_address = "CompAsia Sunway Pyramid\nF1.82 , Jalan PJS 11/15, Bandar Sunway,\n47500 Petaling Jaya, Selangor";
                this.delivery_option = this.customer_order_info[0].delivery_option;
                this.straight_through = this.customer_order_info[0].straight_through;
                this.nric_num = this.customer_order_info[0].nric;
                this.dropoff_cust = this.customer_order_info[0].dropoff;
                this.referer_code = this.customer_order_info[0].referer_code;
                this.pickup_branch = this.customer_order_info[0].pickup_branch;
                this.pickupbranch = this.customer_order_info[0].pickup_branch;
                this.incomeVerificationType = this.customer_order_info[0].income_verification_type || '';
                this.bank_name = this.customer_order_info[0].bank_name || '';
                this.bankStatementUrl = this.customer_order_info[0].bank_statement_url || '';
                this.epfStatementUrl = this.customer_order_info[0].epf_statement_url || '';
                this.payslipUrl = this.customer_order_info[0].payslip_url || '';
                this.supportingDocuments = this.customer_order_info[0].supporting_documents || [];
                this.qualified_tier = this.customer_order_info[0].qualified_tier || '';
                this.n2Result = this.customer_order_info[0].n2_result || '';
                this.n2Remarks = this.customer_order_info[0].n2_remarks || '';


                this.getCreditCheck(this.order_id);
                this.getRequestFormsByOrderId();

                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
                axios.get(process.env.VUE_APP_API_BASEURL + 'customer/checklist/' + this.$route.params.cid)
                  .then(res => {
                    if (res.data && res.data[0]) {
                      this.incomeVerificationType = res.data[0].income_verification_type || this.incomeVerificationType;
                    }
                  })
                  .catch(err => console.error('Error fetching customer check info:', err));


                if(this.customer_order_info[0].credit_check == 1 && this.order_status_id == 7){
                  this.disableGeneratePaymentLink = false;
                } else{
                  this.disableGeneratePaymentLink = true;
                }

                if(this.customer_order_info[0].credit_check == 3 || this.customer_order_info[0].credit_check == 0 ||this.order_status_id == '11') //order_status_id 11 = pending
                {
                  this.creditCheckNotActive = false;
                }

                if(this.order_status_id == 1||this.order_status_id == 2){
                  this.emailconfirm = false;
                }

                if(this.order_status_id == 10||this.order_status_id == 11||this.order_status_id == 6||this.order_status_id == 7||this.order_status_id == 12||this.order_status_id == 1){
                  this.buttonskudisable = false;
                }

                if(this.dropoff_cust == null){
                  this.get_customer_by_id_temp();  
                }
                // get payment history link
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.get(process.env.VUE_APP_API_BASEURL+'getpaymenturldetail/'+this.order_id+'/'+this.$route.params.cid)
                .then(response => {
                  console.log("Payment Details",response.data);
                    if (response) {
                      this.payment_link = response.data.url;
                      this.credit_check_request_by = response.data.requested_by;
                      if(typeof response.data['url'] != 'undefined' && this.disableGeneratePaymentLink == false){
                        this.disableSendEmail = false;
                      }
                      if(response.data.send_to != null){
                      this.email_status = 'Sent';
                      } else {
                        this.email_status = 'Not Send'
                      }
                    } 
                    else {
                      this.messageBag = ['No record.'];
                    }
                })
                .catch(error => {
                    this.messageBag = [error.error];
                });

                //get customer detail
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.get(process.env.VUE_APP_API_BASEURL+'customer/getdetail/'+this.temp_id+'?special=774nkfkdfyg2823nrweltnnskdfj12418flsbdjfnklf76487124')
                .then(response => {
                  console.log("Customer Details",response.data);
                    if (response) {
                      this.order_for = response.data.temporaryInfo['orderfor'];
                      this.program_id = response.data.order['program_id'];
                      this.getListOfColor(this.sku, this.program_id);
                      this.hash = response.data.temporaryInfo['hashvalue'];
                      this.version = response.data.order['version'];
                      this.urlUploadEPF();
                      this.get_branch();
                      if (typeof response.data.finance['net_salary'] !== 'undefined') {
                        this.net_salary = response.data.finance['net_salary'];
                        this.salary_range = response.data.finance['salary_range'];
                        this.nric = response.data.customer['nric'];
                        this.dob = response.data.customer['dob'];
                      }
                      this.has_house_delivery = response.data.program.has_house_delivery;
                    } 
                    else {
                      this.messageBag = ['No record.'];
                    }
                })
                .catch(error => {
                    this.messageBag = [error.error];
                });

                if(this.pickup_branch != null && this.pickup_branch != ''){
                  axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                  axios.get(process.env.VUE_APP_API_BASEURL+'branch/edit/'+this.pickup_branch)
                  .then(response => {
                      if (response && response.data && response.data[0]) {
                          this.branch_info = response.data;
                          this.name = this.branch_info[0].name;
                         
                          this.address = this.branch_info[0].address;
                          this.city = this.branch_info[0].city;
                          this.postcode = this.branch_info[0].postcode;
                          this.state = this.branch_info[0].state;      
                          
                          const formattedAddress = this.branch_info[0].name+',\n'+this.branch_info[0].address+', '+this.branch_info[0].city+',\n'+this.branch_info[0].postcode+','+this.branch_info[0].state;
                          this.pickup_store_address = formattedAddress;
                      } 
                      else {
                          this.pickup_store_address = '---';
                          this.messageBag = ['No record.'];
                      }
                  })
                  .catch(error => {
                      this.pickup_store_address = '---';
                      this.messageBag = [error.error];
                  });
                } else {
                  this.pickup_store_address = '---';
                }
          
                this.payment_status_mandate = this.customer_order_info[1].status;
                this.payment_status_upfront = this.customer_order_info[0].status;
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    getListOfColor(sku, program_id){
        if (!sku || String(sku).trim() === '' || String(sku).trim() === 'null' || String(sku).trim() === 'undefined' || !program_id || String(program_id).trim() === 'null' || String(program_id).trim() === 'undefined') {
            this.listColor = [];
            return;
        }
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'product/listcolor/'+program_id+'/'+sku)
        .then(response => {
            if (response) {
                this.listColor = response.data;
                console.log("List Color",this.listColor);
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    getRequestFormsByOrderId() {
        if (!this.id_order) return;
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'request-forms/order/' + this.id_order)
        .then(response => {
            if (response) {
                this.requestFormsList = response.data.data;

                this.isAlternativeDeviceChanged = this.requestFormsList.some(item => item.status_id == 5);
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    get_customer_mandate_sts(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'customer/customer_mandate_info/'+this.$route.params.cid)
        .then(response => {
          console.log("CUST Mandate Status",response);
            if (response) {
                this.customer_mandate_info = response.data; 
                if(this.customer_mandate_info.status == 1){
                  this.mandate_status = 'Paid';
                  this.mandate_date = this.customer_mandate_info.responseDateTimeMandate
                }
                else{
                  this.mandate_status = 'Not Paid';
                }
                this.mandate_date = this.customer_mandate_info.payment_date || this.customer_mandate_info.created_at;
            } 
            else {
                console.log('customer_mandate_info : No response');
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    get_customer_instantpay_sts(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'customer/customer_instantpay_info/'+this.$route.params.cid)
        .then(response => {
          console.log("CUST Instantpay Status",response);
            if (response) {
                this.customer_instantpay_info = response.data; 
                if(this.customer_instantpay_info.status == 1){
                  this.instantpay_status = 'Paid';
                }
                else{
                  this.instantpay_status = 'Not Paid';
                }
                this.upfrontPaymentDate = this.customer_instantpay_info.responseDateTimeInstantPay || this.customer_instantpay_info.payment_date || this.customer_instantpay_info.created_at || '';
            } 
            else {
                console.log('customer_instantpay_info : No response');
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    update_customer_order(e)
    {
        this.ButtonSeen=true;
        e.preventDefault()
        
        const posting_ = {                
            data_verification: this.data_verification,
            call_verification: this.call_verification,
            order_status_id: this.order_status_id,
            remarks: this.remarks,
        };

        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.post(process.env.VUE_APP_API_BASEURL+'customer/update_customer_orders/'+this.$route.params.cid, posting_)
        .then(response => {
            if (response) {
                this.ButtonSeen=false; 
                alert(response.data.msj);  
                if(this.order_status_id == 7){
                  this.disableGeneratePaymentLink = false;  
                } else{
                  this.disableGeneratePaymentLink = true;
                }
                if(this.email_address != '' && this.disableGeneratePaymentLink == false){
                  this.disableSendEmail = false;
                } else {
                  this.disableSendEmail = true;
                }    
                
                this.get_customer_by_id();
            }
            else{
                this.ButtonSeen=false;
                console.log('tak ok');
            }
        });
    },
    update_customer_program_detail(e)
    {
        this.ButtonSeen=true;
        e.preventDefault()
        
        const posting_ = {                
            sku: this.sku,
            pickup_branch: this.pickup_store,
            program_code: this.order_for,
        };

        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.post(process.env.VUE_APP_API_BASEURL+'customer/update_customer_program_detail/'+this.$route.params.cid, posting_)
        .then(response => {
            if (response) {
                this.ButtonSeen=false; 
                alert(response.data.msj);  
                if(this.order_status_id == 7){
                  this.disableGeneratePaymentLink = false;  
                } else{
                  this.disableGeneratePaymentLink = true;
                }
                if(this.email_address != '' && this.disableGeneratePaymentLink == false){
                  this.disableSendEmail = false;
                } else {
                  this.disableSendEmail = true;
                }    
                
                this.get_customer_by_id();
            }
            else{
                this.ButtonSeen=false;
                console.log('tak ok');
            }
        });
    },
    update_ecom_delivery(e)
    {
        this.ButtonSeen=true;
        e.preventDefault()
        
        const posting_ = {                
            pickupbranch: this.pickupbranch,
            delivery_option: this.delivery_option,
            delivery_address: this.delivery_address,
            delivery_postcode: this.delivery_postcode,
            delivery_city: this.delivery_city,
            delivery_state: this.delivery_state_id,
            id_order: this.id_order,

        };

        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.post(process.env.VUE_APP_API_BASEURL+'customer/update_ecom_delivery/'+this.$route.params.cid, posting_)
        .then(response => {
            if (response) {
                this.ButtonSeen=false; 
                alert(response.data.msj);  
                if(this.order_status_id == 7){
                  this.disableGeneratePaymentLink = false;  
                } else{
                  this.disableGeneratePaymentLink = true;
                }
                if(this.email_address != '' && this.disableGeneratePaymentLink == false){
                  this.disableSendEmail = false;
                } else {
                  this.disableSendEmail = true;
                }    
                
                this.get_customer_by_id();
            }
            else{
                this.ButtonSeen=false;
                console.log('tak ok');
            }
        });
    },
    get_paymentlists(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'order/payment/'+this.$route.params.cid)
        .then(response => {
          //console.log("CUST DATA Detail",response);
            if (response) {
                this.loadingData=false;
                this.paymentLists = response.data;
                console.log("PAYMENT HISTORY",this.paymentLists);                  
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    generate_payment_link(){ 
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
      axios.get(process.env.VUE_APP_API_BASEURL+'getpaymentlink/'+this.order_id+'/'+this.$route.params.cid)
      .then(response => {
        console.log('payment link response', response);
          if (response) {
            this.loadingData=false;
            if(response.data.status == 'error'){
              this.messageBag = ['Fail'];
              Swal.fire({
                  title: 'Fail to generate payment link!',
                  icon: 'warn',
                  timer: 1000,
                  showConfirmButton: false,
              });
            } else {
                this.payment_link = response.data[0];
                if(this.payment_link != '' && this.disableGeneratePaymentLink == false && this.email_address != ''){
                  this.disableSendEmail = false;
                } else {
                  this.disableSendEmail = true;
                }
                console.log("Payment Link",this.payment_link); 
                Swal.fire({
                  title: 'Payment link generated!',
                  icon: 'success',
                  timer: 1000,
                  showConfirmButton: false,
              });
            }
          }  
      })
      .catch(error => {
          this.messageBag = [error.error];
      }); 
    },

    send_email(){
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
      axios.get(process.env.VUE_APP_API_BASEURL+'sendpaymenturl/'+this.order_id+'/'+this.$route.params.cid)
      .then(response => {
        console.log('send email response', response.data);
          if (response) {
              this.loadingData=false;
              if(response.data.status != 'error'){
                this.email_status = 'Sent';
                Swal.fire({
                  title: `Email sent to ${this.email_address}!`,
                  icon: 'success',
                  timer: 2050,
                  showConfirmButton: false,
                });
              } else {
                this.email_status = 'Not Send';
                Swal.fire({
                  title: 'Failed to send email!',
                  icon: 'warning',
                  timer: 2050,
                  showConfirmButton: false,
              });
              }              
          } 
          else {
              this.messageBag = ['Error'];
          }
      })
      .catch(error => {
          this.messageBag = [error.error];
      }); 
    },
    send_email_customer(){
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
      axios.get(process.env.VUE_APP_API_BASEURL+'sendpaymenturl/'+this.order_id+'/'+this.$route.params.cid)
      .then(response => {
        console.log('send email response', response.data);
          if (response) {
              this.loadingData=false;
              if(response.data.status != 'error'){
                this.email_status = 'Sent';
                Swal.fire({
                  title: `Email sent to ${this.email_address}!`,
                  icon: 'success',
                  showConfirmButton: false,
                });
              } else {
                this.email_status = 'Not Send';
                Swal.fire({
                  title: 'Failed to send email!',
                  icon: 'warning',
                  showConfirmButton: false,
              });
              }              
          } 
          else {
              this.messageBag = ['Error'];
          }
      })
      .catch(error => {
          this.messageBag = [error.error];
      }); 
    },
    send_email_success_cust(){

      Swal.fire({
        title: 'Are you sure want to add cron for customer success?',
        icon: 'warning',
        showConfirmButton: true,
        showCancelButton:true,
      }).then((result) => {
        if (result.value) {
          axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
          axios.get(process.env.VUE_APP_API_BASEURL+'customer/add_cron_cust/'+this.id_order)
          .then(response => {
            console.log('send succes email', response.data);
              if (response) {
                  this.loadingData=false;
                  if(response.data.status == "success"){
                    Swal.fire({
                      title: 'Added to cron',
                      icon: 'success',
                      showConfirmButton: false,
                    });
                  }else{
                    Swal.fire({
                      // title: 'Something Wrong',
                      text:   response.data.msj,
                      icon: 'error',
                      showConfirmButton: false,
                    });
                  }
              
              } 
              else {
                  this.messageBag = ['Error'];
              }
          })
          .catch(error => {
              this.messageBag = [error.error];
          }); 
        }
      });
    },
    send_email_success_store(){


      Swal.fire({
        title: 'Are you sure want to add cron for store success?',
        icon: 'warning',
        showConfirmButton: true,
        showCancelButton:true,
      }).then((result) => {
        if (result.value) {

          axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
          axios.get(process.env.VUE_APP_API_BASEURL+'customer/add_cron_store/'+this.id_order)
          .then(response => {
            console.log('send succes email', response.data);
              if (response) {
                  this.loadingData=false;
                  if(response.data.status == "success"){
                    Swal.fire({
                      title: 'Added to cron',
                      icon: 'success',
                      showConfirmButton: false,
                    });
                  }else{
                    Swal.fire({
                      title: response.data.msj,
                      icon: 'error',
                      showConfirmButton: false,
                    });
                  }
              
              } 
              else {
                  this.messageBag = ['Error'];
              }
          })
          .catch(error => {
              this.messageBag = [error.error];
          }); 
        }
      });
    },

    request_credit_check(){
      this.retry = this.retry +1;
      this.loadingCreditCheck = true;
      setTimeout(()=>this.checkingpopup());              
      var posting_ = {};

        posting_ = {                
            orderId: this.id_order,
            customerId: this.$route.params.cid,
            net_salary: this.net_salary,
        };

      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
      axios.post(process.env.VUE_APP_API_BASEURL+'applications/v1/credit-check/customer-service',posting_)
      .then(response => {
      this.loadingCreditCheck = true;
      if (response){
        this.get_customer_by_id();

        
        if(response.data.status == true){
            this.credit_check_result = 'approved';
            this.creditCheckNotActive = true;
            
            Swal.fire({
                title: response.data.msj,
                icon: 'success',
                timer: 20500,
                showConfirmButton: true,
            });
        }
        else {
            this.creditCheckNotActive = false;
            this.credit_check_result = 'Timeout';
            // this.creditCheckFailed = true;
            Swal.fire({
                title: ' Credit check Failed !',
                text:   response.data.msj,
                icon: 'error',
                showConfirmButton: true,
            });    
        }

      } else {
            this.creditCheckNotActive = false;
            this.credit_check_result = 'Timeout';
            // this.creditCheckFailed = true;
            Swal.fire({
                title: ' Credit check Failed !',
                text:   response.data.msj,
                icon: 'error',
                showConfirmButton: true,
            });    
        }
    }).catch(error => {
    this.messageBag = [error.error];
    });


    },

    checkingpopup(){
      Swal.fire({
          title: 'Performing credit check...',
          text:  'Please wait',
          icon: 'warning',
          showConfirmButton: false,
      }); 
    },

    //raw data----------------------------------------------------------
    get_order_status(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'orderstatus/list')
        .then(response => {
            if (response) {
                this.orderstatusList = response.data;
                console.log(this.orderstatusList);
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },

    get_customer_by_id_temp(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'customer/order_details_temp_id/'+this.nric_num)
        .then(response => {
          
            if (response) {
              this.customer_order_info_temp = response.data; 
              this.dropoff_temp = this.customer_order_info_temp.dropoff;
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    },
    //raw data----------------------------------------------------------
    async getReferralOptions() {
      try {
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
        const res = await axios.get(process.env.VUE_APP_API_BASEURL + 'referral/codes');
        this.referralOptions = res.data;
      } catch (e) { console.error(e); }
    },

    async getReferralHistory() {
        if (!this.id_order) return;   // Prevent empty ID call
        try {
          axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
          const res = await axios.get(process.env.VUE_APP_API_BASEURL + `orders/${this.id_order}/referral-history`);
          this.referralHistory = res.data;
          this.get_customer_by_id();
        } catch (e) {
          console.error('Failed to load referral history', e);
        }
      },

    async applyReferral(e) {
      e.preventDefault();
      if (!this.selectedReferralId) return;

      try {
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
        await axios.post(process.env.VUE_APP_API_BASEURL + `customer/apply-referral/${this.id_order}`, {
          referral_code_id: this.selectedReferralId
        });
        alert('Referral code applied successfully!');
        this.selectedReferralId = '';
        this.getReferralHistory();
      } catch (err) {
        alert('Failed to apply referral');
        console.error(err);
      }
    },

    async updateReferral() {
      try {
        const posting_ = {                
            referer_code: this.referer_code,
        };
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.post(process.env.VUE_APP_API_BASEURL+'customer/update/referral/'+this.$route.params.cid, posting_)
        .then(response => {
            if (response.data.message) {
              alert(response.data.message);
            }
          })
      } catch (error) {
        console.error('Failed to update referral.', error);
        alert('Failed to update referral.');
      }
    },
    handleApproveReview() {
      Swal.fire({
        title: 'Approve Bank Statement?',
        text: 'This will approve the bank statement review and update status to Processing.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, Approve',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#0ab39c',
      }).then((result) => {
        if (result.isConfirmed) {
          const posting = {
            decision: 'approved',
            remarks: 'Approved bank statement review',
          };

          const orderId = this.order_id || this.$route.params.cid;
          axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
          axios.post(process.env.VUE_APP_API_BASEURL + 'customer/orders/' + orderId + '/bank-statement-review', posting)
            .then(response => {
              if (response) {
                Swal.fire('Approved!', response.data.message || 'Order status updated to Processing.', 'success');
                this.get_customer_by_id();
              }
            })
            .catch(error => {
              console.error('Approval failed:', error);
              Swal.fire('Error', error.response?.data?.message || 'Failed to approve bank statement review.', 'error');
            });
        }
      });
    },

    handleRejectReview() {
      Swal.fire({
        title: 'Reject Bank Statement?',
        text: 'This will reject the bank statement review and cancel the order.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Reject',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#f06548',
      }).then((result) => {
        if (result.isConfirmed) {
          const posting = {
            decision: 'rejected',
            remarks: 'Failed bank statement review',
          };

          const orderId = this.order_id || this.$route.params.cid;
          axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
          axios.post(process.env.VUE_APP_API_BASEURL + 'customer/orders/' + orderId + '/bank-statement-review', posting)
            .then(response => {
              if (response) {
                Swal.fire('Rejected!', response.data.message || 'Order status updated to Cancelled.', 'info');
                this.get_customer_by_id();
              }
            })
            .catch(error => {
              console.error('Rejection failed:', error);
              Swal.fire('Error', error.response?.data?.message || 'Failed to reject bank statement review.', 'error');
            });
        }
      });
    },

    urlUploadEPF(){
      const host = process.env.VUE_APP_RENEWNGO_WEBCLIENT_HOST || '';
      if (this.version == 2) {
        this.UploadEPFLinkURL = host ? (host + '/applications/v2/orders?hash=' + this.hash) : '';
      } else {
        this.UploadEPFLinkURL = host ? (host + '/applications/upload-documents?temporary_id=' + this.temp_id + '&hash=' + this.hash) : '';
      }
    },

    copyToClipboard(text){
      if (!text || text === '---') return;
      navigator.clipboard.writeText(text).then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Copied!',
          text: 'Link copied to clipboard.',
          timer: 1500,
          showConfirmButton: false
        });
      }).catch(err => {
        console.error('Could not copy text: ', err);
      });
    },

    formatDocumentType(type) {
      if (type === 'EPF_DOCUMENTS' || type == '1') return 'EPF Statement';
      if (type === 'PAYSLIP_DOCUMENTS' || type == '2') return 'Government Payslip';
      if (type === 'BANK_STATEMENT_DOCUMENTS' || type == '3') return 'Bank Statement';
      return type || 'Income Verification';
    },

    getBadgeClass(type) {
      if (type === 'EPF_DOCUMENTS' || type == '1') return 'bg-info text-white';
      if (type === 'PAYSLIP_DOCUMENTS' || type == '2') return 'bg-warning text-dark';
      if (type === 'BANK_STATEMENT_DOCUMENTS' || type == '3') return 'bg-primary';
      return 'bg-secondary';
    },

    isPrimaryIncomeDoc(type) {
      if ((type === 'EPF_DOCUMENTS' || type == '1') && this.incomeVerificationType == 1) return true;
      if ((type === 'PAYSLIP_DOCUMENTS' || type == '2') && this.incomeVerificationType == 2) return true;
      if ((type === 'BANK_STATEMENT_DOCUMENTS' || type == '3') && this.incomeVerificationType == 3) return true;
      return false;
    }
  },

  

  components: {
      Layout,
      PageHeader,
      Select2, 
      //DataTable,
  },

  mounted() {
      this.get_customer_by_id();
      this.get_order_status();
      this.get_customer_mandate_sts();
      this.get_customer_instantpay_sts();
      this.getBranchForDelivery();
      this.GetCollectionData();
      this.getReferralOptions();
      this.getReferralHistory();
    },

  watch: {
    id_order(newVal) {
      if (newVal) this.getReferralHistory();
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header border-0">
              <h3><i class="ri-function-fill text-muted align-bottom me-1"></i>{{ namepernric }}</h3>
          </div>
          <hr class="my-1 text-muted">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="card">
                      <div class="card-header">
                        <div class="d-flex align-items-center justify-content-between">
                          <h5 class="mb-0">Order Details</h5>
                          <span :class="order_version === 2 ? 'badge bg-primary' : 'badge bg-info'" class="fs-12 px-2 py-1">
                            V{{ order_version }}
                          </span>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="live-preview">
                          <form @submit="update_customer_order">
                             <div class="row mb-3">
                               <div class="col-lg-3">
                                 <label for="order_no" class="form-label">Order Number</label>
                               </div>
                               <div class="col-lg-9">
                                 <input v-model='order_no' type="text" class="form-control" id="order_no" readonly/>
                               </div>
                             </div>
                             <div v-if="order_url" class="row mb-3">
                               <div class="col-lg-3">
                                 <label for="order_url" class="form-label">Order URL</label>
                               </div>
                               <div class="col-lg-9">
                                 <div class="input-group">
                                   <input :value="order_url" type="text" class="form-control" id="order_url" readonly/>
                                   <button class="btn btn-outline-primary" type="button" @click="copyToClipboard(order_url)">Copy</button>
                                   <a :href="order_url" target="_blank" rel="noreferrer noopener" class="btn btn-outline-secondary">Open</a>
                                 </div>
                               </div>
                             </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="created_at" class="form-label">Order Date</label>
                              </div>
                              <div class="col-lg-9">
                                <input v-model='created_at' type="text" class="form-control" id="created_at" readonly/>
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="customer_full_name" class="form-label">Customer Name</label>
                              </div>
                              <div class="col-lg-9">
                               <router-link target="_blank" :to="`/customer/customer-details/${customer_id}`" class="fw-medium link-secondary">{{ namepernric }}</router-link>
                                <!-- <a v-bind:href="'/customer/customer-details/'+ customer_id" target="_blank" rel="noreferrer noopener">{{ namepernric }}</a> -->
                                <!--input v-model='customer_full_name' type="text" class="form-control" id="customer_full_name" readonly/-->
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="salary" class="form-label">Status</label>
                              </div>
                              <div class="col-lg-9">
                          <select 
                            v-model="order_status_id" 
                            class="form-select mb-3" 
                            aria-label="Default select example" 
                            :disabled="permissions.canApprove?.value === false && (order_status_id === 1 || order_status_id === 2)">
                            <option v-for="(item, index) in orderstatusList" :key="index" :value="item.id">
                              {{ item.name }}
                            </option>
                          </select>
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="data_verification" class="form-label">Data Verification</label>
                              </div>
                              <div class="col-lg-9">
                                <select v-model="data_verification" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country" required>
                                    <option value="1">
                                        Completed
                                    </option>
                                    <option value="0">
                                        Not Completed
                                    </option>
                                    <option value="2">
                                        Failed
                                    </option>
                                </select>
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="gender" class="form-label">Call Verification</label>
                              </div>
                              <div class="col-lg-9">
                                <select v-model="call_verification" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country" required>
                                    <option value="1">
                                        Completed
                                    </option>
                                    <option value="0">
                                        Not Completed
                                    </option>
                                    <option value="2">
                                        Failed
                                    </option>
                                </select>
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="created_at" class="form-label">Straight Through</label>
                              </div>
                              <div class="col-lg-9">
                                <input :value="displayValue(straight_through)" type="text" class="form-control" id="straight_through" readonly/>
                              </div>
                            </div>
                            <div class="row mb-3">
                              <div class="col-lg-3">
                                <label for="remarks" class="form-label">Remarks</label>
                              </div>
                              <div class="col-lg-9">
                                <textarea v-model="remarks" rows="4" class="form-control" id="remarks" ></textarea>
                              </div>
                            </div>
                            <div class="text-end col-lg-12">
                              <button v-if="permissions.canUpdate?.value" type="submit" class="btn btn-primary">
                                Update
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>        
                  </div>

                  <!--Payment History ------------------------------------>
                  <div class="col-xl-6">    
                    <div class="card">
                      <form @submit="update_customer_program_detail">
                      <div class="card-header">
                        <div class="d-flex align-items-center justify-content-between">
                          <h5 class="mb-0">Program Details</h5>
                          <span v-if="isAlternativeDeviceChanged" class="fs-12 px-2 py-1 badge bg-primary">
                            Device Changed
                          </span>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="live-preview">
                          <div class="row align-items-center g-12">                           
                              <div class="col-lg-12">
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="program_name" class="form-label">Program</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input :value="displayValue(program_name)" type="text" class="form-control" id="program_name" readonly/>
                                    </div>
                                </div>
                                <div v-if="order_for !== 'DLC-eCOMM' && order_for !== 'DLCCA2'" class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="pickup_store" class="form-label">Store Name</label>
                                    </div>
                                    <!-- <div class="col-lg-9">
                                      <input v-model='pickup_store' type="text" class="form-control" id="pickup_store" readonly/>
                                    </div> -->
                                  <div class="col-sm-9">
                                    <Select2 v-model="pickup_store" :options="branchList"></Select2>
                                  </div>
                                </div>
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="program_fee" class="form-label">Program Fee</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input :value="displayValue(program_fee, 'RM ')" type="text" class="form-control" id="program_fee" readonly/>
                                  </div>
                                </div>
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="product_name" class="form-label">Device Name</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input :value="displayValue(product_name)" type="text" class="form-control" id="product_name" readonly/>
                                  </div>
                                </div>
                                
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="product_name" class="form-label">Color</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <select v-model="sku" disabled class="form-select mb-3" arial-label="Default select example" placeholder="Enter Select Color">
                                        <option v-for="(item, index) in listColor" :key="index" :value="item.sku" >
                                            {{ item.name }}
                                        </option>
                                  </select>
                                  </div>
                                </div>
                                
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="sku" class="form-label">SKU</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input :value="displayValue(sku)" type="text" class="form-control" id="sku" readonly/>
                                  </div>
                                </div>
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="salary" class="form-label">Price</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input :value="displayValue(price, 'RM ')" type="text" class="form-control" id="price" readonly/>
                                  </div>
                                </div>
                                <div v-if = "knockOffAmount < 0" class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="salary" class="form-label">Security Deposit Offset</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input :value="displayValue(knockOffAmount, 'RM ')" type="text" class="form-control" id="price" readonly/>
                                  </div>
                                </div>
                                <div v-if = "knockOffAmount < 0" class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="salary" class="form-label">New Monthly Price</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input :value="displayValue(newlyMonthlyAmount, 'RM ')" type="text" class="form-control" id="price" readonly/>
                                  </div>
                                </div>
                                <div v-if = "knockOffAmount < 0" class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="salary" class="form-label">Total Security Deposit</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input :value="displayValue(securityDeposit, 'RM ')" type="text" class="form-control" id="price" readonly/>
                                  </div>
                                </div>
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="salary" class="form-label">Tenure</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input :value="displayValue(tenure)" type="text" class="form-control" id="price" readonly/>
                                  </div>
                                </div>
                                <div class="text-end col-lg-12">
                                  <router-link
                                    v-if="isProcessingStatus && permissions.canRequestAlternativeDevices?.value"
                                    :to="'/device/alternative-devices/create?order_id=' + (id_order || order_id)"
                                    class="btn btn-primary me-2"
                                  >
                                    <i class="ri-swap-line align-middle me-1"></i> Request alternative device
                                  </router-link>
                                  <!-- <button v-if="permissions.canUpdate?.value" type="submit" class="btn btn-primary" :disabled='buttonskudisable'>
                                    Update
                                  </button> -->
                                </div>
                                <div class="mt-2" v-if="requestFormsList.length > 0">
                                  <div class="fw-semibold mb-2"> Alternative Device History: </div> 
                                  <div class="row g-2"> 
                                    <div v-for="item in requestFormsList" :key="item.id" class="col-6 col-md-6 col-lg-6 col-xl-6" > 
                                      <router-link :to="'/device/alternative-devices/details/' + item.id" target="_blank" class="btn btn-soft-primary btn-sm w-100" :title="item.request_number" > 
                                        <i class="ri-external-link-line align-middle me-1"></i> 
                                        {{ item.request_number }} {{ item?.status?.status_name }}
                                      </router-link> 
                                    </div> 
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                     
                      </div>
                    </form>
                    </div>
                    <div class="card">
                      <div class="card-header">
                        <div class="d-flex align-items-center">
                          <h5>Delivery Information</h5>
                        </div>
                      </div>
                      <form @submit="update_ecom_delivery">
                        <div class="card-body">
                        <div class="live-preview">
                          <div class="row align-items-center g-12">                           
                              <div class="col-lg-12">
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="program_name" class="form-label">Delivery Option</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <!-- <input v-model='delivery_option' type="text" class="form-control" id="program_name" readonly/> -->
                                      <select v-model="delivery_option" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country">
                                            <option value="">Please Select Delivery Option</option>
                                            <option value="delivery">Delivery</option>
                                            <option value="pickup">Pickup</option>
                                      </select>
                                    </div>
                                </div>
                                <div v-if="delivery_option == 'delivery'" class="row mb-3">

                                  <label for="placeholderInput" class="form-label " style="font-size: 20px;">Delivery Address</label>
                                      <div class="col-md-6">                                               
                                          <label for="placeholderInput" class="form-label">Zip/Postal<span style="color: red;">*</span></label>
                                          <div class="input-group">
                                              <input type="text" class="form-control" v-model="delivery_postcode" v-on:keypress="NumbersOnly" maxlength="5" aria-label="Recipient's username with two button addons">
                                          </div>                                               
                                      </div>

                                      <div class="col-md-6">                                               
                                          <label for="placeholderInput" class="form-label"> City<span style="color: red;">*</span></label>
                                          <div class="input-group">
                                              <input type="text" class="form-control" v-model="delivery_city" aria-label="Recipient's username with two button addons">
                                          </div>                                               
                                      </div>
                                      <div class="col-md-6">                                                   
                                          <label for="placeholderInput" class="form-label"> State<span style="color: red;">*</span></label>
                                          <div class="input-group">
                                              <select v-model="delivery_state_id" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country">
                                                  <option disabled value="">Please Select State</option>
                                                  <option value="4">Selangor</option>
                                                  <option value="15">Wilayah Persekutuan</option>
                                                  <option value="16">Putrajaya</option>
                                                  <option value="7">Pulau Pinang</option>
                                                  <option value="3">Negeri Sembilan</option>
                                                  <option value="1">Johor</option>
                                                  <option value="2">Melaka</option>
                                                  <option value="5">Perak</option>
                                                  <option value="6">Kedah</option>
                                                  <option value="9">Perlis</option>
                                                  <option value="10">Kelantan</option>
                                                  <option value="11">Terengganu</option>
                                                  <option value="12">Pahang</option>
                                            </select>
                                          </div>                                                    
                                      </div>
                                      <div class="col-md-6">
                                          <label for="placeholderInput" class="form-label"> Country<span style="color: red;">*</span></label>
                                          <div class="input-group">
                                              <select v-model="country" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country" disabled>
                                                  <option value="1" >
                                                      Malaysia
                                                  </option>
                                              </select>
                                          </div>                                                   
                                      </div>
                                      <div class="row col-md-12">
                                        <div class="col-lg-9">
                                        <label for="pickup_store" class="form-label">Delivery Address</label>
                                        </div>
                                        <div class="col-lg-9">
                                          <textarea v-model='delivery_address' type="text" class="form-control" id="pickup_store"/>
                                        </div>
                                      </div>
                                 
                                </div>
                                <div v-else-if="delivery_option == 'pickup'" class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="pickup_store" class="form-label">Change Pickup Store</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <select v-model="pickupbranch" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country">
                                      <option value="">Please Select Pickup Branch</option>
                                      <option v-for="(item, index) in branchListPickup" :key="index" :value="item.id" >{{ item.name }}</option>
                                   </select>
                                  
                                  </div>
                                  <div class="col-lg-3">
                                    <label for="pickup_store" class="form-label">Pickup Store</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <textarea :value="displayValue(pickup_store_address)" type="text" class="form-control" id="pickup_store" readonly/>
                                  </div>
                   
                                </div>
                                <div v-else class="row mb-3">
                                
                                  <div class="col-lg-3">
                                    <label for="pickup_store" class="form-label">Pickup Store</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <textarea :value="'---'" type="text" class="form-control" id="pickup_store" readonly/>
                                  </div>
                                 
                                </div>
                                <div class="text-end col-lg-12">
                                  <button v-if="permissions.canUpdate?.value" type="submit" class="btn btn-primary" :disabled="(has_house_delivery == '1') ? false : true">
                                    Update
                                  </button>
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                      </form>
                      
                    </div>



                  </div>
                </div>
                <div class="row">
                  <!--Payment Details------------------------------------->
                  <div class="col-xl-6">    
                    <div class="card">
                      <div class="card-header">
                        <div class="d-flex align-items-center">
                          <h5>Payment Details</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="live-preview">
                          <div class="row align-items-center g-12">                           
                              <div class="col-lg-12">
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="curlec_reference_no" class="form-label">Reference No</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input :value="displayValue(curlec_reference_no)" type="text" class="form-control" id="curlec_reference_no" readonly/>
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="mandate_status" class="form-label">eMandate Payment Status</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input v-model='mandate_status' type="text" class="form-control" id="mandate_status" readonly/>
                                    </div>
                                  </div>
                                <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="mandate_date" class="form-label">eMandate Payment Date</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input :value="formatDateToWeb(mandate_date, 'DD-MMM-YYYY')" type="text" class="form-control" id="mandate_date" disabled/>
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="cancel_reason" class="form-label">Upfront Payment Status</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input v-model='instantpay_status' type="text" class="form-control" id="instantpay_status" readonly/>
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="cancel_reason" class="form-label">Upfront Payment Date</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input :value="formatDateToWeb(upfrontPaymentDate, 'DD-MMM-YYYY')" type="text" class="form-control" id="upfrontPaymentDate" readonly/>
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="cancel_reason" class="form-label">Cancel Reason</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <textarea :value="displayValue(cancel_reason)" rows="4" class="form-control" id="cancel_reason" disabled></textarea>
                                    </div>
                                  </div>
                                   <div class="row mb-3" v-if="order_status_id == 10">
                                      <div class="col-lg-3">
                                        <label for="payment_link" class="form-label">Link Supporting Document</label>
                                      </div>
                                      <div class="col-lg-9">
                                        <div class="input-group">
                                          <input :value="displayValue(UploadEPFLinkURL)" type="text" class="form-control" id="payment_link" readonly/>
                                          <button class="btn btn-outline-primary" type="button" :disabled="!UploadEPFLinkURL || UploadEPFLinkURL === '---'" @click="copyToClipboard(UploadEPFLinkURL)">Copy</button>
                                        </div>
                                        <span class="text-muted fs-12">(EPF/Payslip/Bank Statement)</span>
                                      </div>
                                    </div>
                                  <div class="row mb-3">
                                     <div class="col-lg-3">
                                       <label for="payment_link" class="form-label">Payment Link</label>
                                     </div>
                                     <div class="col-lg-9">
                                       <div class="input-group">
                                         <input :value="displayValue(payment_link)" type="text" class="form-control" id="payment_link" readonly/>
                                         <button class="btn btn-outline-primary" type="button" :disabled="!payment_link || payment_link === '---'" @click="copyToClipboard(payment_link)">Copy</button>
                                       </div>
                                     </div>
                                   </div>
                                  <div class="mb-3 text-end col-lg-12">
                                    <button v-if="permissions.canCreate?.value" :disabled="disableGeneratePaymentLink" @click="generate_payment_link()" class="btn btn-success">Generate Payment Link</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="email_address" class="form-label">Email Address</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input :value="displayValue(email_address)" type="text" class="form-control" id="email_address" readonly />
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="credit_check_request_by" class="form-label">Request By</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input :value="displayValue(credit_check_request_by)" type="text" class="form-control" id="credit_check_request_by" readonly/>
                                    </div>
                                  </div>
                                  <div class="row mb-3">
                                    <div class="col-lg-3">
                                      <label for="email_status" class="form-label">Email Status</label>
                                    </div>
                                    <div class="col-lg-9">
                                      <input v-model='email_status' type="text" class="form-control" id="email_status" readonly />
                                    </div>
                                  </div>
                                  <div class="text-end col-lg-12">
                                    <button v-if="permissions.canCreate?.value" :disabled="disableSendEmail" @click="send_email()" class="btn btn-success">Send Email</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!--Credit Check Details--------------------------------->
                <div class="col-xl-6">    
                    <div class="card">
                      <div class="card-header">
                        <div class="d-flex align-items-center">
                          <h5>Credit Check Details</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="live-preview">
                          <div class="row align-items-center g-12">                           
                              <div class="col-lg-12">
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="credit_check_result" class="form-label">Credit Check Status</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input :value="displayValue(credit_check_result)" type="text" class="form-control" id="credit_check_result" readonly/>
                                  </div>
                                </div>
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="credit_check_real" class="form-label">Request By</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input :value="displayValue(credit_check_real)" type="text" class="form-control" id="credit_check_real" readonly/>
                                  </div>
                                </div>
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="credit_check_request_datetime" class="form-label">Request Datetime</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input :value="displayValue(format_date(credit_check_request_datetime))" type="text" class="form-control" id="credit_check_request_datetime" readonly/>
                                  </div>
                                </div>
                                <div class="text-end col-lg-12">
                                    <button v-if="permissions.canUpdate?.value" :disabled="creditCheckNotActive" @click="request_credit_check()" class="btn btn-success">Request Credit Check</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                  </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card">
                      <div class="card-header">
                        <div class="d-flex align-items-center">
                          <h5>Dropoff</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="live-preview">
                          <div class="row align-items-center g-12">                           
                              <div class="col-lg-12">
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="credit_check_result" class="form-label">Page</label>
                                  </div>
                                  <div class="col-lg-9">
                                    <input  v-if='this.dropoff_cust != null' v-model='dropoff_cust' type="text" class="form-control" id="credit_check_result" readonly/>
                                    <input v-else v-model='dropoff_temp' type="text" class="form-control" id="credit_check_result" readonly/>

                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card">
                      <div class="card-header">
                        <div class="d-flex align-items-center">
                          <h5>Send Email</h5>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="live-preview">
                          <div class="row align-items-center g-12">                           
                              <div class="col-lg-12">
                                <div class="row mb-3">
                                  <div class="col-lg-3">
                                    <label for="credit_check_result" class="form-label"></label>
                                  </div>
                                  <div class="col-lg-4">

                                    <button v-if="permissions.canUpdate?.value" @click="send_email_success_cust()" class="btn btn-success" :disabled='emailconfirm'>Send Email Confirmation Customer</button> 

                                  </div>
                                  <div class="col-lg-4">
                                    <button v-if="permissions.canUpdate?.value" @click="send_email_success_store()" class="btn btn-success" :disabled='emailconfirm'>Send Email Confirmation Store</button>
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Supporting Documents Section (EPF, Government Payslip, Bank Statement) -->
                    <div class="card" v-if="incomeVerificationType">
                      <div class="card-header d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center gap-2">
                          <h5 class="mb-0">Supporting Documents</h5>
                          <span v-if="isHighValueDevice" class="badge bg-warning-subtle text-warning border border-warning px-2 py-1">
                            <i class="ri-shield-star-line me-1"></i> High-Value Device
                          </span>
                        </div>
                        <span v-if="order_status_id == 14" class="badge bg-warning text-dark px-2 py-1">
                          <i class="ri-error-warning-line me-1"></i> Review Required
                        </span>
                      </div>
                      <div class="card-body">
                        <div class="table-responsive mb-3">
                          <table class="table table-bordered align-middle mb-0">
                            <thead class="table-light">
                              <tr>
                                <th>Document Name</th>
                                <th class="text-center" style="width: 120px;">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <!-- Dynamic Supporting Documents List -->
                              <template v-if="supportingDocuments && supportingDocuments.length">
                                <tr v-for="(doc, idx) in supportingDocuments" :key="idx">
                                  <td>
                                    <div>{{ doc.name || doc.file_name || ('Supporting Document #' + (idx + 1)) }}</div>
                                    <div class="mt-1 d-flex flex-wrap gap-1 align-items-center">
                                      <span class="badge" :class="getBadgeClass(doc.type)">{{ formatDocumentType(doc.type) }}</span>
                                      <span v-if="(doc.type === 'BANK_STATEMENT_DOCUMENTS' || doc.type == '3') && bank_name" class="badge bg-secondary text-uppercase">
                                        <i class="ri-bank-line me-1"></i> {{ bank_name }}
                                      </span>
                                      <span v-if="isPrimaryIncomeDoc(doc.type)" class="badge bg-success text-white">
                                        <i class="ri-checkbox-circle-fill me-1"></i> Latest Uploaded
                                      </span>
                                      <span v-if="isPrimaryIncomeDoc(doc.type) && (n2Result === 'FAILED' || n2Result === 'INVALID')" class="badge bg-danger text-white">
                                        <i class="ri-close-circle-fill me-1"></i> Verification Failed
                                      </span>
                                    </div>
                                    <div v-if="isPrimaryIncomeDoc(doc.type) && (n2Result === 'FAILED' || n2Result === 'INVALID') && n2Remarks" class="mt-1 text-danger small">
                                      <i class="ri-error-warning-line me-1"></i> <strong>Failed Reason:</strong> {{ n2Remarks }}
                                    </div>
                                  </td>
                                  <td class="text-center">
                                    <a v-if="permissions.canApproveOrder?.value" :href="doc.url || doc.path || doc.file_path" target="_blank" rel="noreferrer noopener" class="btn btn-sm btn-outline-primary">
                                      <i class="ri-external-link-line me-1"></i> View
                                    </a>
                                  </td>
                                </tr>
                              </template>
                              <!-- Fallback Rows if supportingDocuments array is empty -->
                              <template v-else>
                                <!-- Bank Statement Document -->
                                <tr v-if="incomeVerificationType == 3 || bankStatementUrl || order_status_id == 14">
                                  <td>
                                    <div>Bank Statement Document</div>
                                     <div class="mt-1 d-flex flex-wrap gap-1 align-items-center">
                                       <span class="badge bg-primary">Bank Statement</span>
                                       <span v-if="bank_name" class="badge bg-secondary text-uppercase">
                                         <i class="ri-bank-line me-1"></i> {{ bank_name }}
                                       </span>
                                     </div>
                                  </td>
                                  <td class="text-center">
                                    <a v-if="bankStatementUrl && permissions.canApproveOrder?.value" :href="bankStatementUrl" target="_blank" rel="noreferrer noopener" class="btn btn-sm btn-outline-primary">
                                      <i class="ri-external-link-line me-1"></i> View
                                    </a>
                                    <span v-else-if="!permissions.canApproveOrder?.value" class="text-muted small">-</span>
                                    <span v-else class="text-muted small">Uploaded Document</span>
                                  </td>
                                </tr>
                                <!-- EPF Statement Document -->
                                <tr v-if="incomeVerificationType == 1 || epfStatementUrl">
                                  <td>
                                    <div>EPF Statement Document</div>
                                    <div class="mt-1">
                                      <span class="badge bg-info text-white">EPF Statement</span>
                                    </div>
                                  </td>
                                  <td class="text-center">
                                    <a v-if="epfStatementUrl && permissions.canApproveOrder?.value" :href="epfStatementUrl" target="_blank" rel="noreferrer noopener" class="btn btn-sm btn-outline-primary">
                                      <i class="ri-external-link-line me-1"></i> View
                                    </a>
                                    <span v-else-if="!permissions.canApproveOrder?.value" class="text-muted small">-</span>
                                    <span v-else class="text-muted small">Uploaded Document</span>
                                  </td>
                                </tr>
                                <!-- Government Payslip Document -->
                                <tr v-if="incomeVerificationType == 2 || payslipUrl">
                                  <td>
                                    <div>Government Payslip Document</div>
                                    <div class="mt-1">
                                      <span class="badge bg-warning text-dark">Government Payslip</span>
                                    </div>
                                  </td>
                                  <td class="text-center">
                                    <a v-if="payslipUrl && permissions.canApproveOrder?.value" :href="payslipUrl" target="_blank" rel="noreferrer noopener" class="btn btn-sm btn-outline-primary">
                                      <i class="ri-external-link-line me-1"></i> View
                                    </a>
                                    <span v-else-if="!permissions.canApproveOrder?.value" class="text-muted small">-</span>
                                    <span v-else class="text-muted small">Uploaded Document</span>
                                  </td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div>
 
                        <!-- Action Buttons for Review Required -->
                        <div v-if="order_status_id == 14 && permissions.canApproveOrder?.value" class="p-3 bg-light rounded border">
                          <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
                            <div>
                              <h6 class="mb-1 text-dark fw-bold">Manual Bank Statement Review Action</h6>
                              <p class="text-muted small mb-0">Please inspect the uploaded income verification documents above before taking action.</p>
                            </div>
                            <div class="d-flex gap-2 justify-content-end ms-auto">
                              <button type="button" class="btn btn-sm btn-danger px-3" @click="handleRejectReview">
                                <i class="ri-close-circle-line me-1"></i> Reject
                              </button>
                              <button type="button" class="btn btn-sm btn-success px-3" @click="handleApproveReview">
                                <i class="ri-checkbox-circle-line me-1"></i> Approve
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div class="card">
                      <div class="card-header">
                        <h5>Referral / Promo Code</h5>
                      </div>
                      <div class="card-body">
                        <form @submit.prevent="applyReferral">
                          <div class="row mb-3">
                            <div class="col-lg-3">
                              <label class="form-label">Applied Referral Code</label>
                            </div>
                            <div class="col-lg-9">
                              <input v-model="referer_code" type="text" class="form-control" readonly />
                            </div>
                          </div>

                          <div class="row mb-3">
                            <div class="col-lg-3">
                              <label class="form-label">Apply New Referral Code</label>
                            </div>
                            <div class="col-lg-9">
                              <select v-model="selectedReferralId" class="form-select">
                                <option value="">Select Referral Code</option>
                                <option v-for="ref in referralOptions" :key="ref.id" :value="ref.id">
                                  {{ ref.code }}
                                  <span v-if="ref.email">({{ ref.email }})</span>
                                  <span v-if="ref.type === 'promo'"> - Promo</span>
                                </option>
                              </select>
                            </div>
                          </div>

                          <div class="text-end">
                            <button type="submit" class="btn btn-success" :disabled="!selectedReferralId">
                              Apply Referral Code
                            </button>
                          </div>
                        </form>

                        <hr class="my-4">

                        <!-- Improved History Section -->
                        <div class="d-flex align-items-center justify-content-between mb-3">
                          <h6 class="mb-0 fw-semibold">
                            <i class="ri-history-line text-muted me-1"></i>
                            Referral Application History
                          </h6>
                          <span
                            v-if="referralHistory && referralHistory.length"
                            class="badge bg-soft-secondary text-secondary"
                          >
                            {{ referralHistory.length }} record{{ referralHistory.length !== 1 ? 's' : '' }}
                          </span>
                        </div>

                        <!-- Empty state -->
                        <div
                          v-if="!referralHistory || referralHistory.length === 0"
                          class="text-center py-4 border rounded bg-light"
                        >
                          <i class="ri-file-list-3-line fs-2 text-muted d-block mb-2"></i>
                          <p class="text-muted mb-0 small">No referral application history yet.</p>
                        </div>

                        <!-- History table -->
                        <div v-else class="table-responsive">
                          <table class="table table-hover table-bordered align-middle mb-0">
                            <thead class="table-light">
                              <tr>
                                <th scope="col" class="text-nowrap" style="width: 22%;">Date Applied</th>
                                <th scope="col" class="text-nowrap">Code</th>
                                <th scope="col" class="text-nowrap text-center" style="width: 14%;">Type</th>
                                <th scope="col">Email</th>
                                <th scope="col" class="text-nowrap">Applied By</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="history in referralHistory" :key="history.id">
                                <td class="text-nowrap text-muted small">
                                  {{ format_date(history.created_at) || '—' }}
                                </td>
                                <td>
                                  <span class="fw-semibold font-monospace">
                                    {{ history.referral_code?.code || '—' }}
                                  </span>
                                </td>
                                <td class="text-center">
                                  <span
                                    class="badge rounded-pill"
                                    :class="(history.referral_code?.type || '').toLowerCase() === 'promo'
                                      ? 'bg-soft-info text-info'
                                      : 'bg-soft-primary text-primary'"
                                  >
                                    {{ history.referral_code?.type
                                      ? (history.referral_code.type.charAt(0).toUpperCase() + history.referral_code.type.slice(1))
                                      : '—' }}
                                  </span>
                                </td>
                                <td class="text-break">
                                  {{ history.email || '—' }}
                                </td>
                                <td>
                                  <span class="d-inline-flex align-items-center">
                                    <i class="ri-user-line text-muted me-1"></i>
                                    {{ history.user?.name || 'System' }}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div class="text-end col-lg-12">
                    <a @click="$router.go(-1)" class="btn btn-success">Back</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </div>

                  </div>


                </div>
              
           
            <!--end tab-content-->
    
          <!--end card-body-->
        </div>
        
        <!--end card -->
      </div>
      
      <!--end card -->
    </div>
    
    <!--end row-->
  </Layout>
</template>